export const SUPPORT_SEARCH_CUSTOMER_START = 'SUPPORT_SEARCH_CUSTOMER_START';
export const SUPPORT_SEARCH_CUSTOMER_SUCCESS = 'SUPPORT_SEARCH_CUSTOMER_SUCCESS';
export const SUPPORT_SEARCH_CUSTOMER_FAIL = 'SUPPORT_SEARCH_CUSTOMER_FAIL';
export const SUPPORT_SEARCH_CUSTOMER_RESET_STATUS = 'SUPPORT_SEARCH_CUSTOMER_RESET_STATUS';

export const CREATE_APPLICATION_START = 'CREATE_APPLICATION_START';
export const CREATE_APPLICATION_SUCCESS = 'CREATE_APPLICATION_SUCCESS';
export const CREATE_APPLICATION_FAIL = 'CREATE_APPLICATION_FAIL';

export const GET_SUBSCRIBER_START = 'GET_SUBSCRIBER_START';
export const GET_SUBSCRIBER_SUCCESS = 'GET_SUBSCRIBER_SUCCESS';
export const GET_SUBSCRIBER_FAIL = 'GET_SUBSCRIBER_FAIL';

export const GET_APPLICATIONS_START = 'GET_APPLICATIONS_START';
export const GET_APPLICATIONS_SUCCESS = 'GET_APPLICATIONS_SUCCESS';
export const GET_APPLICATIONS_FAIL = 'GET_APPLICATIONS_FAIL';

export const GET_DETAILED_APPLICATION_START = 'GET_DETAILED_APPLICATION_START';
export const GET_DETAILED_APPLICATION_SUCCESS = 'GET_DETAILED_APPLICATION_SUCCESS';
export const GET_DETAILED_APPLICATION_FAIL = 'GET_DETAILED_APPLICATION_FAIL';

export const PATCH_HANDLER_APPLICATION_START = 'PATCH_HANDLER_APPLICATION_START';
export const PATCH_HANDLER_APPLICATION_SUCCESS = 'PATCH_HANDLER_APPLICATION_SUCCESS';
export const PATCH_HANDLER_APPLICATION_FAIL = 'PATCH_HANDLER_APPLICATION_FAIL';

export const GET_BALANCE_START = 'GET_BALANCE_START';
export const GET_BALANCE_SUCCESS = 'GET_BALANCE_SUCCESS';
export const GET_BALANCE_FAIL = 'GET_BALANCE_FAIL';

export const GET_TRANSACTIONS_START = 'GET_TRANSACTIONS_START';
export const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';
export const GET_TRANSACTIONS_FAIL = 'GET_TRANSACTIONS_FAIL';

export const GET_BONUSES_START = 'GET_BONUSES_START';
export const GET_BONUSES_SUCCESS = 'GET_BONUSES_SUCCESS';
export const GET_BONUSES_FAIL = 'GET_BONUSES_FAIL';
